import React from 'react';
import { Stack } from '@mui/material';
import { formatCurrency } from 'utils';
import { green } from '@mui/material/colors';
import Typography from '@mui/material/Typography';
import { useFormContext, useWatch } from 'react-hook-form';
import { EquipmentFormValue } from '../../../../types';

export const Totals = () => {
  const { control } = useFormContext<EquipmentFormValue>();
  const calcPricing = useWatch({ control, name: 'calcPricing' });

  const render = [
    {
      title: 'Total Wholesale Cost:',
      value: calcPricing.wholesale.total,
    },
    {
      title: 'Total Retail Price:',
      value: calcPricing.retail.total,
    },
    {
      title: 'Total Customer Price:',
      value: calcPricing.customer.total,
    },
  ];

  return (
    <Stack direction="row" gap="2rem">
      {render.map(({ title, value }) => (
        <Stack key={title} direction="row" gap="0.5rem">
          <Typography sx={{ color: green[800] }} variant="body1">
            {title}
          </Typography>

          <Typography sx={{ color: green[800] }}>{formatCurrency(value, true)}</Typography>
        </Stack>
      ))}
    </Stack>
  );
};
